import React, { useState } from 'react';
import styles from './MenuSection.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import MenuItem from './MenuItem';
import { useLocation } from 'react-router-dom';

/**
 * Menu section component that groups related menu items
 * Implements collapsible sections with accessibility support
 */
const MenuSection = ({ title, items, icon, OnHide, disableNavigation = false, allowedRoutes = [] }) => {
    const sectionId = `menu-section-${title.toLowerCase().replace(/\s+/g, '-')}`;
    const location = useLocation();

    // Check if any child menu item is active
    const hasActiveChild = items.some(item => location.pathname === item.path);

    // A seção da página atual já abre expandida
    const [isExpanded, setIsExpanded] = useState(hasActiveChild);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className={styles.section}>
            <button
                className={`${styles.sectionHeader} ${hasActiveChild ? styles.hasActiveChild : ''}`}
                onClick={toggleExpand}
                aria-expanded={isExpanded}
                aria-controls={sectionId}
            >
                <span className={`${styles.sectionIcon} ${hasActiveChild ? styles.sectionIconActive : ''}`}>
                    {icon}
                </span>
                <span className={styles.title}>{title}</span>
                <FontAwesomeIcon
                    icon={isExpanded ? faChevronDown : faChevronRight}
                    className={styles.chevron}
                />
            </button>
            
            <div
                id={sectionId}
                className={`${styles.sectionContent} ${isExpanded ? styles.expanded : styles.collapsed}`}
                aria-hidden={!isExpanded}
            >
                {items.map((item) => (
                    <MenuItem
                        key={item.path}
                        path={item.path}
                        icon={item.icon}
                        label={item.label}
                        OnHide={OnHide}
                        disableNavigation={disableNavigation && !allowedRoutes.includes(item.path)}
                    />
                ))}
            </div>
        </div>
    );
};

export default MenuSection;